import React from "react";
import { Star, Quote } from "lucide-react";

const familyImage =
  "https://images.unsplash.com/photo-1593100126453-19b562a800c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxmYW1pbHklMjBnZW5lcmF0aW9uc3xlbnwwfHx8fDE3ODI2ODQ3NDl8MA&ixlib=rb-4.1.0&q=85";

const REVIEWS = [
  {
    name: "Linda M.",
    age: 68,
    location: "Tampa, FL",
    quote:
      "I was paying $84 a month and worried I'd lose my coverage. They found me the same benefit for $31 in one call. The agent was patient and never rushed me.",
  },
  {
    name: "Robert K.",
    age: 72,
    location: "Phoenix, AZ",
    quote:
      "No medical exam, no hassle. I was approved on the phone in under 15 minutes. My wife and I both have peace of mind now.",
  },
  {
    name: "Carolyn S.",
    age: 65,
    location: "Charlotte, NC",
    quote:
      "On a fixed Social Security income, every dollar counts. They didn't try to sell me something I couldn't afford. Honest folks.",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-16 md:py-24 bg-[#fdf8ee]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2rem] bg-amber-100 -z-10" />
            <img
              src={familyImage}
              alt="A grandmother sharing a warm moment with her granddaughter"
              data-testid="family-image"
              loading="lazy"
              className="w-full h-[420px] md:h-[520px] object-cover rounded-[2rem] shadow-xl border border-white"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-green-700">
            Real Stories
          </p>
          <h2
            data-testid="testimonials-heading"
            className="font-serif-display mt-3 text-3xl md:text-5xl font-bold leading-tight tracking-tight text-blue-900"
          >
            Trusted by seniors across America.
          </h2>

          <div className="mt-8 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="h-6 w-6 text-amber-500 fill-amber-500"
                />
              ))}
            </div>
            <span className="text-lg font-semibold text-slate-800">
              4.9 / 5 from 2,800+ seniors
            </span>
          </div>

          <div className="mt-8 space-y-5">
            {REVIEWS.map((r, idx) => (
              <figure
                key={idx}
                data-testid={`testimonial-${idx}`}
                className="bg-white rounded-2xl p-6 md:p-7 border border-slate-200 shadow-sm relative"
              >
                <Quote className="absolute top-5 right-5 h-7 w-7 text-amber-300" />
                <blockquote className="text-lg md:text-xl text-slate-800 leading-relaxed pr-8">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-blue-900 text-white flex items-center justify-center font-serif-display font-bold">
                    {r.name.charAt(0)}
                  </div>
                  <div className="text-base">
                    <div className="font-bold text-slate-900">
                      {r.name}, age {r.age}
                    </div>
                    <div className="text-slate-600">{r.location}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
